module.exports = __webpack_public_path__ + "assets/fonts/GothamProNarrow-Medium.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/gothampro/GothamProNarrow-Medium.ttf
// module id = 1912
// module chunks = 0